/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthGoogleAccessTokenRequest } from '../models/AuthGoogleAccessTokenRequest';
import type { AuthGoogleAccessTokenResponseApiRespoonse } from '../models/AuthGoogleAccessTokenResponseApiRespoonse';
import type { AuthLoginGoogleRequest } from '../models/AuthLoginGoogleRequest';
import type { AuthLoginGoogleResponseApiRespoonse } from '../models/AuthLoginGoogleResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GoogleService {

    /**
     * Google Auth
     * @param requestBody
     * @returns AuthLoginGoogleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminGoogleAuth(
        requestBody: AuthLoginGoogleRequest,
    ): CancelablePromise<AuthLoginGoogleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/google/auth',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Google access token
     * @param requestBody
     * @returns AuthGoogleAccessTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminGoogleAccessToken(
        requestBody: AuthGoogleAccessTokenRequest,
    ): CancelablePromise<AuthGoogleAccessTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/google/access-token',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
